module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', {
    class: _vm.data,
    attrs: {
      "id": "girl4"
    }
  }, [_c('rect', {
    attrs: {
      "id": "girl4_bag_3",
      "width": "28.57",
      "height": "39.02",
      "x": "6076.37",
      "y": "301.06",
      "fill": "#A98448",
      "rx": "14.29"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_hand",
      "fill": "#E2B56C",
      "d": "M6057.1 357.27c-.2 1.36-1.27 2-2.44 3.47-1.35 1.72-1.72 5.1-3.33 7.76.25.7 2.5-.25 3.1-1.34.57-1.08 1.03-1.96 1.22-2.23.2-.27.55-.2.62.1.07.28-1.1 10.2-.93 10.7.15.53 1.42.72 1.7.25.3-.48 1.42-8.3 1.56-8.5.13-.2.4-.05.5.07.1.13-1.33 8.45-1.18 8.8.14.33 1.45.45 1.63.2.18-.23 1.45-8.55 1.62-8.72.17-.17.46-.1.55.07.1.2-1.4 8.16-1.25 8.54.15.37 1.42.54 1.6.2.16-.32 1.6-8.35 1.74-8.45.15-.1.3-.08.4.04.1.12-.65 6.16-.5 6.52.16.35 1.1.56 1.3.17.2-.38 1.7-15.16 1.83-15.97.46-2.7-.8-5.77-4.12-6.2-3.3-.46-5.14 1.6-5.6 4.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_arm_bottom",
      "fill": "#E2B56C",
      "d": "M6065.52 329.1c2.72.27 4.7 2.64 4.42 5.3l-2.55 23.53c-.3 2.65-2.74 4.58-5.47 4.3-2.73-.28-4.7-2.66-4.42-5.3l2.56-23.54c.28-2.67 2.73-4.6 5.46-4.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_arm_top",
      "fill": "#E2B56C",
      "d": "M6068.26 303c2.73.3 4.7 2.67 4.42 5.32l-2.8 25.93c-.3 2.66-2.73 4.58-5.46 4.3-2.73-.28-4.7-2.65-4.42-5.3l2.8-25.94c.3-2.64 2.73-4.57 5.46-4.3z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_sleeve",
      "fill": "#BC9555",
      "d": "M6068.16 303.1c2.78.3 4.84 2.63 4.72 5.34l-.55 11.6-11.86-1.2 1.94-11.47c.47-2.67 3-4.54 5.76-4.26z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_shoe",
      "fill": "#91713D",
      "d": "M6065 441.22c3.2-1.2 7.48-1.52 9.2-.37.72 1.62 1.04 5.2.72 6.88-2.74 0-13.56.02-16.9 0-2.94-.03-3.2-2.74-1.3-3.88 1.3-.53 5.1-1.44 8.3-2.63z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_ankle",
      "fill": "#E2B56C",
      "d": "M6067.32 432.9h6.54c-.06 3.95.25 6.68.9 8.2-1.5 1.48-5.65 1.45-8.93 1.45-1.57 0-4.06-.22-.75-1.6 1.73-.72 2.48-3.4 2.24-8.06z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_leg_bottom",
      "fill": "#91713D",
      "d": "M6070.4 387.5c4.12 0 7.46 3.33 7.46 7.45v37.94h-14.9v-37.95c0-4.12 3.33-7.45 7.45-7.45z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl4_right_leg_top",
      "width": "14.9",
      "height": "56.98",
      "x": "6062.95",
      "y": "345",
      "fill": "#91713D",
      "rx": "7.45"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_shoe",
      "fill": "#91713D",
      "d": "M6084.88 441.22c3.2-1.2 7.47-1.52 9.2-.37.7 1.62 1.03 5.2.7 6.88-2.73 0-13.55.02-16.88 0-2.94-.03-3.22-2.74-1.32-3.88 1.32-.53 5.1-1.44 8.3-2.63z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_ankle",
      "fill": "#E2B56C",
      "d": "M6087.2 432.9h6.53c-.05 3.95.25 6.68.9 8.2-1.5 1.48-5.65 1.45-8.93 1.45-1.56 0-4.05-.22-.74-1.6 1.73-.72 2.47-3.4 2.23-8.06z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_leg_bottom",
      "fill": "#91713D",
      "d": "M6090.28 387.5c4.1 0 7.45 3.33 7.45 7.45v37.94h-14.9v-37.95c0-4.12 3.33-7.45 7.45-7.45z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_leg_top",
      "fill": "#91713D",
      "d": "M6090.28 345c4.1 0 7.45 3.34 7.45 7.45v42.08c0 4.12-3.34 7.46-7.45 7.46-4.12 0-7.45-3.35-7.45-7.47v-42.08c0-4.1 3.33-7.45 7.45-7.45z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_hip",
      "fill": "#91713D",
      "d": "M6062.95 349.83h34.78c0 8-6.5 14.5-14.5 14.5h-5.8c-8 0-14.48-6.5-14.48-14.5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_zipper",
      "fill": "#A98448",
      "d": "M6077.86 349.85v9.66c-3.6-2.4-4.2-4.95-4.47-9.65.82.05 3.8-.05 4.46 0z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_torso",
      "fill": "#BC9555",
      "d": "M6067.44 305.83c3.73-6.6 21.7-6.13 25.94 0 2.82 4.1 4.27 18.9 4.35 44.43h-34.78c.5-25.23 2-40.03 4.5-44.43z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_bag_2",
      "fill": "#A98448",
      "d": "M6088.32 302.03c1.32 0 4.05.3 5.13 1.38-6.73 0-4.82 23.87-3.83 26.37 0 .9-.2 4.05 0 5.1-7.35-5.13-7.64-25.74-1.3-32.84z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_bag_1",
      "fill": "#A98448",
      "d": "M6066.75 304.68c1.16-1.1 2.17-1.6 4.08-2.17-2.6 10.44-6.57 26.24-7.37 32.18-.18-14.85 2.37-29.14 3.3-30z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_hand",
      "fill": "#E2B56C",
      "d": "M6089.35 357.8c-.06 1.38-1.06 2.1-2.05 3.7-1.17 1.85-1.17 5.23-2.5 8.05.34.67 2.47-.5 2.94-1.63.47-1.14.83-2.06 1-2.35.15-.28.5-.25.6.02.12.27.03 10.26.24 10.76.2.5 1.5.55 1.73.05.25-.5.52-8.38.63-8.6.12-.2.4-.1.5.03.12.1-.4 8.53-.22 8.85.2.32 1.5.3 1.66.06.15-.26.52-8.66.67-8.85.15-.2.44-.16.56 0 .1.18-.53 8.27-.34 8.62.2.36 1.47.4 1.6.05.13-.35.7-8.48.83-8.6.12-.1.3-.1.4.02.1.1 0 6.2.2 6.52.2.34 1.16.45 1.3.04.17-.4.05-15.24.1-16.06.17-2.74-1.4-5.66-4.76-5.77-3.36-.1-4.95 2.13-5.1 5.08z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_arm_bottom",
      "fill": "#E2B56C",
      "d": "M6094.25 329.07c2.75 0 4.97 2.22 4.97 4.97v23.38c0 2.74-2.22 4.97-4.97 4.97-2.74 0-4.97-2.24-4.97-4.98v-23.38c0-2.75 2.23-4.97 4.97-4.97z"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "id": "girl4_left_arm_top",
      "width": "9.94",
      "height": "35.73",
      "x": "6089.28",
      "y": "302.99",
      "fill": "#E2B56C",
      "rx": "4.97"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_sleeve",
      "fill": "#BC9555",
      "d": "M6094.25 303c2.8 0 5.1 2.16 5.27 4.95l.7 11.46h-11.93l.68-11.45c.17-2.8 2.48-4.96 5.27-4.96z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_neck",
      "fill": "#E2B56C",
      "d": "M6076 298.15c2.22-1.3 5.73-1.25 7.96 0-.07 2.36-.1 4.7 1.55 5.98-1.25 2.92-8.68 3.05-10.62 0 .94-1.27 1.4-4.27 1.13-5.98z"
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "id": "girl4_head"
    }
  }, [_c('path', {
    attrs: {
      "id": "girl4_hair",
      "fill": "#91713D",
      "d": "M6083.56 257.23c2.04-6.27 10.64-4.58 13.9-2.97 3.24 1.62 5.44 6.5 5.8 9.84.36 3.36-1.45 8.26 1.95 13.2 3.42 4.92 1.67 12.7 0 17.2-1.65 4.54-1.17 6.8.8 10.07-5.35-1.16-11.8-3.8-11.8-14.2 0-10.4 3.07-24.18 1.22-26.27-1.85-2.08-13.9-.6-11.86-6.87z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_face",
      "fill": "#E2B56C",
      "d": "M6079.57 258.08c17.27.07 17.94 10.12 17.78 18.58 8.4-.72 2.15 15.7-4.05 12.9-.75 2.1-2.86 10.03-14.24 9.9-11.37-.14-14.93-12.87-15.1-21.27-.17-8.42 1.18-20.18 15.6-20.12z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_mouth_bottom",
      "fill": "#D3A862",
      "fill-rule": "nonzero",
      "d": "M6074.88 293.88c.84.2 5.54.25 7.1-.05.84-.16-1.04 1.37-4.17 1.37s-2.92-1.32-2.92-1.32z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_mouth_top",
      "fill": "#D3A862",
      "fill-rule": "nonzero",
      "d": "M6074.38 294.07c0-.66.52-1.22 3.24-1.22 1.88 0 4.9.9 6.42.5.32-.1.32.16-.1.3-1.93.67-3.8.67-6.7.67-1.87-.05-2.86-.25-2.86-.25z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_nose",
      "fill": "#D3A862",
      "d": "M6076.7 281.08c0-1 2.64-1.1 2.65 0 0 1.1.85 6.8 0 7.8-.86 1-3.36.67-3.75 0-.4-.68-.32-1.77.53-2.08.84-.3.56-4.72.56-5.72z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_eye_whites",
      "fill": "#FBD79E",
      "d": "M6082.83 281.56c1.4-3.75 7.6-4.32 8.55-1.07 0 4.37-7.54 4.76-8.55 1.06z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "girl4_left_pupil",
      "cx": "6087.94",
      "cy": "281.41",
      "fill": "#91713D",
      "rx": "2.14",
      "ry": "2.08"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_eye_whites",
      "fill": "#FBD79E",
      "d": "M6074.5 281.56c-1.4-3.75-7.63-4.32-8.57-1.07 0 4.37 7.54 4.76 8.56 1.06z"
    }
  }), _vm._v(" "), _c('ellipse', {
    attrs: {
      "id": "girl4_right_pupil",
      "cx": "6071.55",
      "cy": "281.41",
      "fill": "#91713D",
      "rx": "2.14",
      "ry": "2.08"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_left_brow",
      "fill": "#91713D",
      "d": "M6082.87 275.44c1.07-.56 6.7-.66 7.94 0 1.25.66.34 1.8-.52 1.54-.86-.26-5.96-.3-6.88 0-.9.3-1.6-.97-.53-1.54z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_right_brow",
      "fill": "#91713D",
      "d": "M6074.48 275.44c-1.07-.56-6.7-.66-7.94 0-1.24.66-.33 1.8.53 1.54.86-.26 5.96-.3 6.88 0 .9.3 1.6-.97.53-1.54z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "id": "girl4_bangs",
      "fill": "#91713D",
      "d": "M6081.35 256.64c-18.5-.25-20 16-19.88 20.74 1.9 14.2-2.4 14.6 2.7 33.04.07 0 1.85-1.4 2.8-2.24-4.1-13.15-.83-16.67-2.8-30.8h7.78c.46-4.2 1.4-7.28 2.78-9.2-.44 2.62-.44 5.68 0 9.2h8.92c-.42-2.88-.42-5.4 0-7.6.92 1.55 1.98 4.08 3.17 7.6h5.13c.73-1.23 1.3-3.34 1.68-6.32 1.93 18-8.02 21.84-1.68 40.33.7-.47 2.2-2 2.74-2.76-4-12.8 3.2-18.26 3.2-32 0-5.86 1.94-19.76-16.55-20z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e01b08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/module_2/backgroundCharacters/girlFour.vue
// module id = 656
// module chunks = 1